import { LDFlagSet } from "launchdarkly-js-client-sdk"
import { useFlags } from "launchdarkly-react-client-sdk"

// --------------------------------------------------------------------------------------------------------------------

export type Flags = Readonly<{
  claimsDetailsDialog: boolean
  showHereMap: boolean
  useNewTripViews: boolean
  useMissingClaimsDataStatusBar: boolean
  showFrequencyAndTotalExcess: boolean
  showPolicyDropdown: boolean
  disableVehicleMtas: boolean
  showNewPoliciesPage: boolean
  useInternalEfnol: boolean
  useFmgEfnol: boolean
  useCharges: boolean
}>

// --------------------------------------------------------------------------------------------------------------------

export const makeFlags = (flags: LDFlagSet): Flags => ({
  claimsDetailsDialog: flags.claimsDetailsDialog ?? false,
  useNewTripViews: flags.useNewTripViews ?? true,
  showHereMap: flags.showHereMap ?? false,
  useMissingClaimsDataStatusBar: flags.useMissingClaimsDataStatusBar ?? false,
  showFrequencyAndTotalExcess: flags.showFrequencyAndTotalExcess ?? false,
  showPolicyDropdown: flags.showPolicyDropdown ?? false,
  disableVehicleMtas: flags.disableVehicleMtas ?? false,
  showNewPoliciesPage: flags.showNewPoliciesPage ?? false,
  useInternalEfnol: flags.useInternalEfnol ?? false,
  useFmgEfnol: flags.useFmgEfnol ?? false,
  useCharges: flags.useCharges ?? false,
})

export const mockFlags = (config?: Partial<Flags>): Flags => ({
  claimsDetailsDialog: false,
  useNewTripViews: false,
  showHereMap: false,
  useMissingClaimsDataStatusBar: false,
  showFrequencyAndTotalExcess: false,
  showPolicyDropdown: false,
  disableVehicleMtas: false,
  showNewPoliciesPage: false,
  useInternalEfnol: false,
  useFmgEfnol: false,
  useCharges: false,
  ...config,
})

export const useLDFlags = () => makeFlags(useFlags())
